module.exports = __webpack_public_path__ + "static/img/200319.edc4d327.png";